// @ts-check
import { getActiveSize } from 'modules/looks/components/StyleboardProductDetailsList/utils';
import actions from '../actions/actionTypes';

const getActiveVariant = (variants, variantId) => variants.find((variant) => variant.variantId === variantId);

const mapStyleboardData = (payload) => ({
  id: payload.id,
  title: payload.title,
  author: payload.author,
  popularity: payload.popularity,
  featuredProductId: payload.featuredProductId,
  products: payload.children,
  styleboardTemplate: payload.template,
  styleboardTemplateX10: payload.templateX10,
  looksImageURL: payload.looksImageURL,
  isPublished: payload.isPublished,
  desc: payload.desc,
  frame: payload.frame,
  frameColor: payload.frameColor,
  rawTemplate: payload.rawTemplate,
  expiryDate: payload.expiryDate,
});

const mapStyleboardDataIds = (products) => {
  return products.map(({ id, productId, subProductId, variantId, variants, sku }) => {
    const variant = getActiveVariant(variants, variantId);
    const size = getActiveSize(variant.sizes);
    return {
      id,
      subProductId,
      productId,
      variantId,
      sku: sku || size.sku,
    };
  });
};

export const INITIAL_STATE = {
  data: {
    products: [],
  },
  loading: false,
  error: null,
  isStyleboardUpdated: false,
  newStyleboardId: null,
};

const looksReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actions.EDITS_PAGE_LOADING:
      return {
        ...state,
        loading: true,
      };
    case actions.EDITS_PAGE_SUCCESS:
      return {
        ...state,
        data: mapStyleboardData(payload),
        styleboardDataIds: mapStyleboardDataIds(payload.children),
        loading: false,
      };
    case actions.EDITS_PAGE_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    case actions.EDITS_PAGE_UPDATE_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          products: payload.children,
          styleboardTemplate: payload.template,
          styleboardTemplateX10: payload.templateX10,
          rawTemplate: payload.rawTemplate,
        },
        styleboardDataIds: payload.updatedStyleboardIds,
        isStyleboardUpdated: true,
        loading: false,
      };
    case actions.EDITS_PAGE_SAVE_SUCCESS:
      return {
        ...state,
        loading: false,
        newStyleboardId: payload,
        isStyleboardUpdated: false,
      };
    case actions.EDITS_PAGE_SAVE_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    case actions.EDITS_PAGE_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case actions.EDITS_PAGE_DELETE_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    case actions.CLEAR_EDITS_PAGE_SUCCESS:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default looksReducer;
